export default __webpack_public_path__ + "static/help-community-4a0eecea968e06ed2d8e3034927fdd2a.png";